
@switch (config.type) {
  @case (listItemType.CARD) {
    <div
      class="w-full flex items-center shadow-[0_6px_14px_#00000033] bg-[#fefefe0d] hover:bg-[#fefefe1a] rounded-10 border-2 border-solid"
      [ngClass]="{
        'border-white/5': !isSelected,
        'border-cyan-highlight': isSelected,
      }"
      nrcAspectRatio
    >
      <div
        class="relative flex flex-col items-center w-full h-full"
        nrcHoverDelay
        [debounceTimeMouseLeave]="200"
        [targetId]="'actionButtonMenu-'+ index"
      >
        @if (config.thumbnailConfig && config.mimetype) {
          <nrc-media-preview
            class="absolute top-0 left-0 flex justify-center w-full h-full overflow-hidden rounded-10"
            [mimetype]="config.mimetype"
            [source]="config['thumbnailSource'] | toString"
            [thumbnailSource]="config['thumbnailSource'] | toString"
            [mediaPreviewTypes]="['image', 'video-snippet']"
            (click)="handleItemClickEvent(index)"
          />
        }

        @if (showCheckbox) {
          <nrc-checkbox
            class="absolute left-0 top-1"
            [checkStatus]="isSelected ? 'checked' : 'unchecked'"
          />
        }

        @if (config['buttonConfigs']) {
          <div class="absolute flex flex-col space-y-1 top-1 right-1">
            @for (buttonConfig of config['buttonConfigs']; track buttonConfigIndex; let buttonConfigIndex = $index) {
              @if (!buttonConfig['visibilityFn'] || buttonConfig['visibilityFn'] | evaluate: (config.originalValue | extractProperty: buttonConfig.key)) {
                <nrc-button
                  class="relative w-8 h-8"
                  [icon]="buttonConfig['extractorFn'] ? (buttonConfig['extractorFn'] | evaluate: (config.originalValue | extractProperty: buttonConfig.key) | toString) : (config.value | toString)"
                  [buttonType]="buttonType.ICON"
                  [role]="actionRole.SECONDARY"
                  [disabled]="buttonConfig['disabled']"
                  [tooltipText]="buttonConfig['tooltipTextFn'] ? (buttonConfig['tooltipTextFn'] | evaluate: (config.originalValue | extractProperty: buttonConfig.key)) : buttonConfig['tooltipText']"
                  (clickEvent)="configButtonClickEvent.emit({ index: buttonConfigIndex, key: buttonConfig.key })"
                />
              }
            }
          </div>
        }

        <!-- Action buttons for each item -->
        @if (showContextMenu) {
          <div
            class="absolute z-20 hidden transition duration-1000 ease-in-out delay-1000 transform -translate-x-1/2 translate-y-1 rounded-lg bg-transparent-dark backdrop-blur-10 top-full left-1/2"
            [id]="'actionButtonMenu-' + index"
          >
            <div class="grid grid-cols-1 divide-y divide-[#2d2d2d] w-56 justify-center items-start">
              @for (actionButton of config['itemActionButtons']; track $index) {
                <div class="flex flex-row items-center justify-between px-4 py-2 cursor-pointer">
                  <nrc-action-button-menu-item
                    class="flex justify-between w-full"
                    [icon]="actionButton?.icon"
                    [label]="actionButton?.label"
                    [role]="actionButton?.role"
                    (clickEvent)="handleItemActionButtonClickEvent(actionButton, index)"
                  />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="flex flex-col items-start w-full pt-2">
      <div class="relative flex flex-col items-center justify-center w-full">
        <div class="flex flex-row w-full peer">
          <span
            class="overflow-hidden text-sm text-ellipsis whitespace-nowrap"
            [ngClass]="{
              'text-white font-light': !config.isHighlighted,
              'text-cyan font-semibold': config.isHighlighted && isSelected,
            }"
          >
            {{ config.value }}
          </span>
        </div>

        @if (config.showTooltip) {
          <nrc-tooltip
            class="tooltip tooltip-peer w-52"
            [text]="config.value | toString"
          />
        }
      </div>

      <div class="flex flex-row">
        @if (config.additionalInfo) {
          <span class="text-sm font-light text-white/50">
            {{ config.additionalInfo | toString }}
          </span>
        }
      </div>
    </div>
  }
}
